<template>
  <div>
    <span v-for="(attachment, index) in attachments" :key="index">
      <v-chip
        class="ma-1 elevation-2"
        color="cardSurface"
        :close="close"
        :disabled="disableClick"
        @click.stop="clickOnFile(attachment)"
        @click:close="remove(attachment)"
      >
        <v-avatar left>
          <v-icon>
            {{ getFileIcon(attachment.extension) }}
          </v-icon>
        </v-avatar>
        {{ attachment.fileName }}
      </v-chip>
    </span>

    <MultiImagesDialog
      v-model="showImages"
      :images.sync="images"
      titleName="name"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import notifications from "@/helpers/notification";
import MultiImagesDialog from "@/components/shared/dialog/MultiImagesDialog.vue";
import { clickOnFile, getFileIcon } from "@/helpers/files";

export default Vue.extend({
  props: {
    attachments: {
      required: true,
    },
    returnClickOnFile: {
      type: Boolean,
      default: false,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showImages: false,
      images: [] as any,
      getFileIcon,
    };
  },
  methods: {
    async clickOnFile(attachment) {
      if (attachment && attachment.status !== 2) {
        var res = await clickOnFile(attachment, this.attachments);
        if (res) {
          this.images = res;
          this.showImages = true;
        }
      } else {
        notifications.warn(
          "Nye filer må lagres, før det blir mulig å åpne fil!"
        );
      }
    },
    remove(attachment) {
      notifications.warn("Det er ikke mulig å slette enda!");
      this.$emit("remove", attachment);
    },
  },
  components: {
    MultiImagesDialog,
  },
});
</script>
